import Urls from "../../constants/urls";
import bathroom from "./imgs/bathroom.jpg";
import bedroomView from "./imgs/bedroomView.jpg";
import office from "./imgs/office.jpg";
import kitchen from "./imgs/kitchen.jpg";
import outdoorBackView from "./imgs/outdoorBackView.jpg";
import outdoorView from "./imgs/outdoorView.jpg";

export const bathroomHotspots = [
  {
    type: "arrow",
    zPosition: -4,
    yPosition: -35,
    xPosition: 25,
    xRotation: -90,
    yRotation: 100,
    zRotation: 168,
    radius: 4,
    link: Urls.realEstate.kitchen.path,
  },
];

export const bedroomViewHotspots = [
  {
    type: "arrow",
    xPosition: 55,
    yPosition: -45,
    zPosition: -38,
    xRotation: -100,
    yRotation: -170,
    zRotation: 0,
    radius: 6,
    link: Urls.realEstate.office.path,
  }
];

export const officeHotspots = [
  {
    type: "arrow",
    zPosition: 25,
    yPosition: -25,
    xPosition: 15,
    xRotation: -100,
    yRotation: 90,
    zRotation: 188,
    radius: 5,
    link: Urls.realEstate.outdoorView.path,
  },
  {
    type: "spot",
    zPosition: -35,
    yPosition: -25,
    xPosition: 12,
    xRotation: -100,
    yRotation: 90,
    zRotation: 355,
    radius: 4,
    link: Urls.realEstate.kitchen.path,
  },
  {
    type: "arrow",
    zPosition: -24,
    yPosition: -25,
    xPosition: -24,
    xRotation: -80,
    yRotation: 90,
    zRotation: 30,
    radius: 4,
    link: Urls.realEstate.bedroomView.path,
  },
];

export const kitchenHotspots = [
  {
    type: "arrow",
    zPosition: 100,
    yPosition: -50,
    xPosition: -30,
    xRotation: -90,
    yRotation: 70,
    zRotation: 130,
    radius: 9,
    link: Urls.realEstate.office.path,
  },
  {
    type: "arrow",
    zPosition: 85,
    yPosition: -25,
    xPosition: 3,
    xRotation: -90,
    yRotation: 100,
    zRotation: 175,
    radius: 7,
    link: Urls.realEstate.outdoorView.path,
  },
  {
    type: "arrow",
    zPosition: -2,
    yPosition: -35,
    xPosition: -20,
    xRotation: -90,
    yRotation: 100,
    zRotation: 78,
    radius: 4,
    link: Urls.realEstate.bathroom.path,
  },
];

export const outdoorBackViewHotspots = [
  {
    type: "arrow",
    xPosition: 15,
    yPosition: -15,
    zPosition: -45,
    xRotation: -90,
    yRotation: 90,
    zRotation: 330,
    radius: 6,
    link: Urls.realEstate.outdoorView.path,
  }
];

export const outdoorViewHotspots = [
  {
    type: "arrow",
    xPosition: 20,
    yPosition: -25,
    zPosition: -50,
    xRotation: -90,
    yRotation: 90,
    zRotation: 0,
    radius: 7,
    link: Urls.realEstate.office.path,
  },
  {
    type: "arrow",
    xPosition: -55,
    yPosition: -25,
    zPosition: -55,
    xRotation: -90,
    yRotation: 90,
    zRotation: 0,
    radius: 7,
    link: Urls.realEstate.outdoorBackView.path,
  }
];

export const rooms = [
  {
    name: "Bathroom",
    img: bathroom,
    route: Urls.realEstate.bathroom,
    yRotation: 360,
  },
  {
    name: "Bedroom View",
    img: bedroomView,
    route: Urls.realEstate.bedroomView,
    yRotation: 90,
  },
  {
    name: "Kitchen",
    img: kitchen,
    route: Urls.realEstate.kitchen,
    yRotation: 90,
  },
  {
    name: "Outdoor Back View",
    img: outdoorBackView,
    route: Urls.realEstate.outdoorBackView,
    yRotation: 90,
  },
  {
    name: "Outdoor View",
    img: outdoorView,
    route: Urls.realEstate.outdoorView,
    yRotation: 90,
  },
  {
    name: "Office",
    img: office,
    route: Urls.realEstate.office,
    yRotation: 90,
  },
];
